import request from 'superagent';

const API_URL = window.API_URL;

class ApiClient {
    defaultHeaders = {};
    errorInterceptor;

    constructor() {
        this.addDefaultHeaders({
            'Content-Type': 'application/json',
        });
    }

    addDefaultHeaders(headers) {
        this.defaultHeaders = {
            ...this.defaultHeaders,
            ...headers,
        };

        return this;
    }

    setErrorInterceptor(interceptor) {
        this.errorInterceptor = interceptor;
    }

    removeFromDefaultHeaders(headers) {
        const commonKeys = Object.keys(this.defaultHeaders).filter((key) => headers[key]);

        commonKeys.forEach((key) => {
            delete this.defaultHeaders[key];
        });

        return this;
    }

    clearDefaultHeaders() {
        this.defaultHeaders = {};

        return this;
    }

    performRequest(callingMethod, options) {
        const url = options.absolute ? options.url : (API_URL + options.url);

        return callingMethod(url)
            .set({
                ...this.defaultHeaders,
                ...options.headers,
            })
            .query(options.query)
            .send(options.body)
            .then((response) => response.body)
            .catch((error) => {
                if (!this.errorInterceptor) {
                    return Promise.reject(error);
                }

                return this.errorInterceptor(error);
            });
    }

    get(options) {
        return this.performRequest(request.get, options);
    }

    post(options) {
        return this.performRequest(request.post, options);
    }

    put(options) {
        return this.performRequest(request.put, options);
    }

    patch(options) {
        return this.performRequest(request.patch, options);
    }

    del(options) {
        return this.performRequest(request.del, options);
    }
}

export default new ApiClient();



// WEBPACK FOOTER //
// ./src/services/ApiClient.js